import { ITabAction, TabState } from "../actions/types/tabTypes";

const initialState: TabState = {
  tabs: [],
  tabSelectIndex: "-1",
  tabSelectWithWarning: false,
  max: 5,
  isMax: false,
};

export const tabReducer = (
  state = initialState,
  action: ITabAction<any>
): TabState => {
  switch (action.type) {
    case "TAB_ADD": {
      let index = 0;
      state.tabs.forEach((tab) => {
        // index = (tab.index !== undefined ? tab.index : 0) + 1
        if (tab.index > index) {
          index = tab.index;
        }
      });
      action.payload.index = index + 1;
      state.tabs.unshift(action.payload);
      return {
        ...state,
        tabSelectIndex: action.payload.index.toString(),
      };
    }
    case "TAB_SET_USER":
      state.tabs.forEach((tab) => {
        if (tab.index === action.payload.index) {
          action.payload.user.indexTab = tab.index;
          tab.state = action.payload.user;
        }
      });
      return {
        ...state,
      };
    case "TAB_SET_USER_MULTIPLE_EXIT":
      state.tabs.forEach((tab) => {
        if (tab.index === action.payload.index) {
          action.payload.user.indexTab = tab.index;
          tab.states = action.payload.user;
        }
      });
      return {
        ...state,
      };
    case "TAB_CLOSE":
      return {
        ...state,
        tabs: state.tabs.filter((tab) => tab.index !== action.payload),
        tabSelectIndex:
          state.tabSelectIndex === action.payload.toString()
            ? initialState.tabSelectIndex
            : state.tabSelectIndex,
      };
    case "TAB_SELECT":
      return {
        ...state,
        tabSelectIndex: state.tabs.some(
          (tab) => tab.index.toString() === action.payload
        )
          ? action.payload
          : initialState.tabSelectIndex,
      };
    case "TAB_SHOW_LIMIT":
      return {
        ...state,
        isMax: action.payload,
      };
    case "TAB_SELECT_WITH_WARNING":
      return {
        ...state,
        tabSelectWithWarning: action.payload,
      };
    default:
      return state;
  }
};
